// notificationQueue.ts

type NotificationItem = {
  id: string;
  title: string;
  body: string;
};

class NotificationQueue {
  private queue: NotificationItem[] = [];
  private isProcessing = false;
  private maxQueueSize = 10;

  add(notification: NotificationItem) {
    // Prevent duplicates
    if (this.queue.find((q) => q.id === notification.id)) return;

    // Limit queue size
    if (this.queue.length >= this.maxQueueSize) {
      this.queue.shift(); // remove oldest
    }

    this.queue.push(notification);
    this.processQueue();
  }

  private async processQueue() {
    if (this.isProcessing) return;

    this.isProcessing = true;

    while (this.queue.length > 0) {
      const item = this.queue.shift();
      if (!item) continue;

      await this.showNotification(item);
    }

    this.isProcessing = false;
  }

 private showNotification(item: NotificationItem): Promise<void> {
  return new Promise((resolve) => {
    if (Notification.permission !== "granted") {
      resolve();
      return;
    }

    // 🔊 Play sound safely
    try {
      const audio = new Audio("/notification.mp3");
      audio.volume = 0.8;

      // Some browsers block autoplay → handle promise
      audio.play().catch(() => {
        console.warn("Sound blocked by browser autoplay policy");
      });
    } catch (err) {
      console.error("Audio error:", err);
    }

    const notification = new Notification(item.title, {
      body: item.body,
      tag: item.id,
    });

    // Auto close after 4 sec
    setTimeout(() => {
     // notification.close();
      resolve();
    }, 4000);

    notification.onclick = () => {
      notification.close();
      resolve();
    };
  });
}
}

export const notificationQueue = new NotificationQueue();